export const isTestEnv =
  process.env.REACT_APP_ENVIRONMENT !== "PRODUCTION" &&
  process.env.REACT_APP_ENVIRONMENT !== "QA"

export const isProdEnv = process.env.REACT_APP_ENVIRONMENT === "PRODUCTION"
export const isQAEnv = process.env.REACT_APP_ENVIRONMENT === "QA"
